module.exports = __webpack_public_path__ + "static/media/moleculer_dep_2.5d253f4e.jpeg";